export default function () {
  $('#findStoresAgain').click(function () {
    $('#latitude').val(null);
    $('#longitude').val(null);
  });
}
